import { Portal, useToast } from "@chakra-ui/react";
import { useState } from "react";
import AdminNavbar from "components/Navbars/AdminNavbar";
import ResetPasswordInput from "./ResetPasswordInput";
import { clientsApiAction } from "stores/redux/apiSlices/clientApi/clientApiSlice";

const LoginContainer = () => {
  const toast = useToast();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [resetPassword] = clientsApiAction.resetPasswordApi();

  const validate = () => {
    let newErrors = {};

    if (!password) {
      newErrors.password = "Ο κωδικός είναι απαραίτητος.";
    } else if (password.length < 6) {
      newErrors.password = "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Επιβεβαίωσε τον κωδικό σου.";
    } else if (confirmPassword !== password) {
      newErrors.confirmPassword = "Οι κωδικοί δεν ταιριάζουν.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    const resetPayload = {
      password,
      confirmPassword,
    };

    try {
      await resetPassword(resetPayload).unwrap();

      toast({
        title: "Επιτυχής αλλαγή",
        description: "Ο κωδικός σου άλλαξε με επιτυχία.",
        status: "success",
        duration: 4000,
        isClosable: true,
      });

      // redirect or reset state if needed
    } catch (error) {
      toast({
        title: "Αποτυχία",
        description: error?.data?.message || "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  const breadcrumbs = [
    {
      label: "Επαναφορά κωδικού",
    },
  ];

  return (
    <>
      <Portal>
        <AdminNavbar logoText="ΚΡΕΑΡΙΣΤΟΝ" breadcrumbs={breadcrumbs} />
      </Portal>

      <ResetPasswordInput
        password={password}
        confirmPassword={confirmPassword}
        setPassword={setPassword}
        setConfirmPassword={setConfirmPassword}
        errors={errors}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default LoginContainer;
